import { useQuery } from '@tanstack/react-query';
import {
  getMyBadgesOptions,
  getMyBalanceOptions,
  getMyBoxesOptions,
} from '@api/generated/@tanstack/react-query.gen';

// The caller's XP/level + token balance. `enabled` gates on auth.
export function useMyBalance(enabled: boolean) {
  return useQuery({
    ...getMyBalanceOptions(),
    enabled,
    staleTime: 1000 * 60,
  });
}

export function useMyBadges(enabled: boolean) {
  return useQuery({
    ...getMyBadgesOptions(),
    enabled,
    staleTime: 1000 * 60 * 5,
  });
}

export function useMyBoxes(enabled: boolean) {
  return useQuery({
    ...getMyBoxesOptions(),
    enabled,
    staleTime: 1000 * 60,
  });
}
